import React, { useEffect } from "react";
import Navbar from "@/components/Navbar";
import Hero from "@/components/Hero";
import Services from "@/components/Services";
import Gallery from "@/components/Gallery";
import About from "@/components/About";
import Certifications from "@/components/Certifications";
import Careers from "@/components/Careers";
import ServiceArea from "@/components/ServiceArea";
import ContactForm from "@/components/ContactForm";
import Footer from "@/components/Footer";

export default function Home() {
  useEffect(() => {
    document.title = "Epicom Systems Ltd. — Towers, Wireless, Networking & DAS | Southern Alberta";
  }, []);

  return (
    <div data-testid="home-page" className="bg-bg-primary text-white">
      <Navbar />
      <main>
        <Hero />
        <Services />
        <Gallery />
        <About />
        <Certifications />
        <Careers />
        <ServiceArea />
        <ContactForm source="epicom-systems" />
      </main>
      <Footer />
    </div>
  );
}
